__webpack_require__.p = "/bangtinh_tragop/";